import { render, staticRenderFns } from "./DialogWeb.vue?vue&type=template&id=6517c4ef&"
import script from "./DialogWeb.vue?vue&type=script&lang=js&"
export * from "./DialogWeb.vue?vue&type=script&lang=js&"
import style0 from "./DialogWeb.vue?vue&type=style&index=0&id=6517c4ef&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports